import React from "../_snowpack/pkg/react.js";
import MarkerIcon from "../assets/icons/sunrise-marker.js";
export const MapMarker = (props) => {
  return /* @__PURE__ */ React.createElement("div", {
    style: {width: 32, height: 48, cursor: "pointer", transform: "translate(-16px, -48px)"}
  }, /* @__PURE__ */ React.createElement(MarkerIcon, null));
};
